import { render, staticRenderFns } from "./trainModel.vue?vue&type=template&id=66f24cb0&scoped=true&"
import script from "./trainModel.vue?vue&type=script&lang=js&"
export * from "./trainModel.vue?vue&type=script&lang=js&"
import style0 from "./trainModel.vue?vue&type=style&index=0&id=66f24cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f24cb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
